export enum EProductGroupType {
    VISITING_CARD = 'VISITING_CARD',
    PREMIUM_VISITING_CARD = 'PREMIUM_VISITING_CARD',
    LATTER_PED = 'LATTER_PED',
    COVER = 'COVER',
    GSM_ART_MIX_250 = '250_GSM_ART_MIX',
    STICKER_PER_SQ_INCH = 'STICKER_PER_SQ_INCH',
    ART_PAPER_100_130_170_GSM = 'ART_PAPER_100_130_170_GSM',
    SPECIAL_JOB = 'SPECIAL_JOB',
}
